<template>
  <div>
    <qx-card
      :title="$route.query.type === 'approve' ? '审核挂车' : '查看挂车'"
      class="detail"
      v-loading="loading"
    >
      <!-- 订单详情数据 -->
      <qx-detail-box v-for="(data, index) in detailData" :data="data" :key="index" label-width="170px">
        <span slot="isUseCarOilCost" slot-scope="prop">
          <span>{{ prop.isUseCarOilCost ? '是' : '否' }}</span>
        </span>
      </qx-detail-box>
      <!-- 订单详情数据 end -->
    </qx-card>
    <ApproveBox
      v-if="(type ||$route.query.type) === 'approve'"
      :busiId="id ? String(id) : $route.query.id"
      busiCode="100009"
      :customPost="true"
      @sub="sub"
      :inFast="Boolean(id)"
      :handleRefresh="handleRefresh"
    />
  </div>
</template>

<script>
import {
  getTrailerByTrailerId,
  getTrailerVerByTrailerId,
} from 'api/car';
import { approve, getFileUrl } from 'api';
import ApproveBox from 'components/approveBox';
import detailDataInit from './detailDataInit';
const cloneDetailData = (data) => JSON.parse(JSON.stringify(data || {}));
export default {
  components: {
    ApproveBox,
  },
  props: {
    id: {
      type: Number,
    },
    type: {
      type: String,
    },
    handleRefresh: {
      type: Function,
      default: null,
    },
  },
  data () {
    return {
      detailRes: {},
      detailVerRes: {},
      loading: false,
      detailData: {},
    };
  },
  computed: {
    colSpan () {
      const total = 24;
      const minSpan = 4;
      return parseInt(total / this.orderInfo.length, 10) < minSpan ? minSpan : parseInt(total / this.orderInfo.length, 10);
    },
  },
  watch: {
    '$route.query.id': function () {
      // 监听id来刷新页面，因为会出现多个查看详情的tab，用的都是同一个页面，所以需要监听id来回请求获取当前id的数据
      this.getData();
    },
  },
  methods: {
    // 根据车辆类型设置对应的展示数据
    setDetailDataByVehicleClass (detailRes) {
      if (detailRes.vehicleClass === 2) {
        // 如果是外调挂车，只需要展示基础信息和车辆参数的一部分字段
        this.detailData = cloneDetailData(detailDataInit.outward);
      } else {
        // 如果不是外调挂车，展示全部字段
        this.detailData = cloneDetailData(detailDataInit.normal);
      }
      this.detailRes = detailRes;
    },
    async getData () {
      // 遇到这两个URL就阻止页面刷新
      if (this.$route.path !== '/manage/car/trailer/archives/detail' && !this.id) {
        return;
      }
      this.loading = true;
      const detailRes = await getTrailerByTrailerId({
        trailerId: this.id || this.$route.query.id,
      });
      this.$emit('vehicleInfo', detailRes || {});
      const detailVerRes = await getTrailerVerByTrailerId({
        trailerId: this.id || this.$route.query.id,
      });
      // this.detailRes = detailRes;
      // this.detailVerRes = detailVerRes;
      this.loading = false;
      if (detailRes && !detailRes.failed) {

        if (detailRes.ext) {
          if (detailRes.ext.brandModel) {
            detailRes.ext.brandModelExt = detailRes.ext.brandModel;
          } else if (detailRes.trailer.brandModel) {
            detailRes.ext.brandModelExt = detailRes.trailer.brandModel;
          }
        }

        const mergeAlldetailRes = {
          ...(detailRes.ext || {}),
          ...(detailRes.trailer || {}),
          ...(Array.isArray(detailRes.lineRelList) ? {} : (detailRes.lineRelList || {})),
          ...(Array.isArray(detailRes.lineRelStr) ? {} : (detailRes.lineRelStr || {})),
          ...(detailRes.trailerRel || {}),
        };
        this.setDetailDataByVehicleClass(mergeAlldetailRes);

        const mergeAlldetailVerRes = {
          ...((detailVerRes && detailVerRes.ext) || {}),
          ...((detailVerRes && !Array.isArray(detailVerRes.lineRelVerStr) && detailVerRes.lineRelVerStr) || {}),
          ...((detailVerRes && detailVerRes.trailer) || {}),
          ...((detailVerRes && detailVerRes.trailerRel) || {}),
        };
        if ((this.id || this.$route.query.type === 'approve') && (detailVerRes && !detailVerRes.failed)) {
          this.setDetailDataByVehicleClass(mergeAlldetailVerRes);
          if (mergeAlldetailVerRes.drivingLicenseDate) {
            mergeAlldetailVerRes.drivingLicenseDate = this.formatDate(mergeAlldetailVerRes.drivingLicenseDate);
          }
          if (mergeAlldetailVerRes.vehicleValidityExpiredTime) {
            mergeAlldetailVerRes.vehicleValidityExpiredTime = this.formatDate(mergeAlldetailVerRes.vehicleValidityExpiredTime);
          }

          for (let item in this.detailData) {
            if (this.detailData[item]) {
              this.detailData[item].tableData.approveData = mergeAlldetailVerRes;
            }
          }
        }
        if (mergeAlldetailRes.drivingLicenseDate) {
          mergeAlldetailRes.drivingLicenseDate = this.formatDate(mergeAlldetailRes.drivingLicenseDate);
        }
        if (mergeAlldetailRes.vehicleValidityExpiredTime) {
          mergeAlldetailRes.vehicleValidityExpiredTime = this.formatDate(mergeAlldetailRes.vehicleValidityExpiredTime);
        }
        let flowIds = [];
        if (mergeAlldetailRes.drivingLicenseId) {
          flowIds.push(mergeAlldetailRes.drivingLicenseId);
        }
        if (mergeAlldetailRes.adriverLicenseCopyId) {
          flowIds.push(mergeAlldetailRes.adriverLicenseCopyId);
        }
        // 重置一下展示的字段长度，防止来回切换 tab 的时候图片字段不断增多
        this.detailData.imgInfo.tableData.title.length = 4;
        if (mergeAlldetailRes.carRegistrationPicture) {

          flowIds.push(mergeAlldetailRes.carRegistrationPicture);
          for (let i = 0;i < mergeAlldetailRes.carRegistrationPicture.split(',').length;i++) {
            this.detailData.imgInfo.tableData.title.push({
              prop: 'pic' + i,
              label: '车辆登记证书图片' + (i + 1),
              type: 'img',
            });
          }
        } else {
          this.detailData.imgInfo.tableData.title.push({
            prop: 'pic',
            label: '车辆登记证书图片',
            type: 'img',
          });
        }
        this.detailData.imgInfo.tableData.title.push({
          prop: 'vehiclePictureUrl',
          label: '车辆图片',
          type: 'img',
        });
        if (mergeAlldetailRes.vehiclePicture) {
          flowIds.push(mergeAlldetailRes.vehiclePicture);
        }
        if (flowIds.length) {
          const urlRes = await getFileUrl({
            flowIds: flowIds.join(','),
            _GRID_TYPE: 'jq',
          });

          const urlRows = Array.isArray(urlRes && urlRes.rows) ? urlRes.rows : [];
          urlRows.forEach((item) => {
            if (item.flowId === mergeAlldetailRes.drivingLicenseId) {
              mergeAlldetailRes.drivingLicense = item.fullPath;
            }
            if (item.flowId === mergeAlldetailRes.adriverLicenseCopyId) {
              mergeAlldetailRes.adriverLicenseCopyObj = item.fullPath;
            }
            if (item.flowId === Number(mergeAlldetailRes.vehiclePicture)) {
              mergeAlldetailRes.vehiclePictureUrl = item.fullPath;
            }
            mergeAlldetailRes.carRegistrationPicture ? mergeAlldetailRes.carRegistrationPicture.split(',').forEach((itemFlowId, index) => {
              if (item.flowId === Number(itemFlowId)) {
                mergeAlldetailRes['pic' + index] = item.fullPath;
              }
            }) : '';
          });
        }
        for (let item in this.detailData) {
          if (this.detailData[item]) {
            this.detailData[item].tableData.data = mergeAlldetailRes;
          }
        }


      }
    },
    async sub (formData) {
      // if ((!this.detailVerRes.trailer && !this.detailRes.trailer.drivingLicenseId) || (!this.detailRes.trailer.drivingLicenseId && !this.detailVerRes.trailer.drivingLicenseId)) {
      //   this.$message({
      //     type: 'info',
      //     message: '行驶证正本图片为空，请先修改！',
      //   });
      //   return;
      // }
      // 手动提交审核
      if (formData) {
        // 【2022042201】修改审核参数没有的问题   --By liuyanming
        let res = await approve({
          ...formData,
          busiId: this.id || this.detailRes.trailerId,
          busiCode: '100009',
        });
        if (!res.failed) {
          this.$message({
            type: 'success',
            message: '保存成功',
          });
          this.close();
        }
      }
    },
  },
  created () {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
@import 'styles/config.scss';
.orderStatusBox {
  overflow: auto;
}
.orderInfoBox {
  margin: 16px 12px 0;
  min-height: 124px;
  border: 1px solid $border-color;
  padding: 24px 16px;
  box-sizing: border-box;
  .title {
    font-size: 16px;
    height: 16px;
    line-height: 16px;
    padding-bottom: 16px;
  }
  .desc,
  .time {
    color: #666;
    line-height: 16px;
  }
  .desc {
    padding-bottom: 12px;
  }
}
.box {
  border-top: 1px solid $border-color;
  border-left: 1px solid $border-color;
  border-right: 1px solid $border-color;
}
.itemLabel {
  background: $grey;
}
.itemLabel,
.itemText {
  height: 48px;
  line-height: 48px;
  padding: 0 24px;
  box-sizing: border-box;
  border-bottom: 1px solid $border-color;
}
.auth-state {
  padding-left: 10px;
}
.no {
  color: red;
}
</style>
